export default __webpack_public_path__ + "static/1-284acf2478a41dc57ba04ff553246ae3.jpg";